import React, { memo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const DeleteModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 h-screen overflow-y-auto bg-[#37383813] bg-opacity-50 flex items-start justify-center z-50 px-4 ">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md mt-9">
        {/* Header with icon */}
        <div className="bg-gray-500 p-4 rounded-t-lg flex items-center justify-center">
          <div className="bg-white p-2 rounded-full relative top-10">
            <FontAwesomeIcon icon={faTrash} className="h-5 w-5 text-red-600" />
          </div>
        </div>

        {/* Text content */}
        <div className="p-6 text-center">
          <h2 className="text-red-600 text-xl font-bold">Warning</h2>
          <p className="text-gray-700 mt-2">
            Are you sure you want to delete this broadcast?
          </p>
        </div>

        {/* Buttons */}
        <div className="flex justify-around p-4">
          <button
            className="px-6 py-2 border border-gray-500 text-gray-500 rounded hover:bg-gray-50"
            onClick={onClose}
          >
            No
          </button>
          <button
            className="px-6 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
            onClick={onConfirm}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default memo(DeleteModal);
